import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "test-container" };
const _hoisted_2 = { class: "card" };
const _hoisted_3 = { class: "input-section" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
    key: 0,
    class: "loading"
};
const _hoisted_6 = {
    key: 1,
    class: "error"
};
const _hoisted_7 = {
    key: 2,
    class: "result"
};
const _hoisted_8 = { class: "json-box" };
const _hoisted_9 = {
    key: 3,
    class: "images"
};
const _hoisted_10 = { class: "image-grid" };
const _hoisted_11 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", null, "测试获取用户图片", -1)),
            _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("label", null, "用户ID：", -1)),
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userId) = $event)),
                    type: "text",
                    placeholder: "请输入用户ID",
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(
                    //@ts-ignore
                    (...args) => (_ctx.handleGetImages && _ctx.handleGetImages(...args)), ["enter"]))
                }, null, 544), [
                    [_vModelText, _ctx.userId]
                ])
            ]),
            _createElementVNode("button", {
                class: "btn-get",
                onClick: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_ctx.handleGetImages && _ctx.handleGetImages(...args))),
                disabled: _ctx.loading || !_ctx.userId
            }, _toDisplayString(_ctx.loading ? '加载中...' : '获取用户图片'), 9, _hoisted_4),
            (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 🔄 正在获取数据... "))
                : _createCommentVNode("", true),
            (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " ❌ " + _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
            (_ctx.responseData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "响应结果：", -1)),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("pre", null, _toDisplayString(JSON.stringify(_ctx.responseData, null, 2)), 1)
                    ])
                ]))
                : _createCommentVNode("", true),
            (_ctx.imageList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("h2", null, "图片列表 (" + _toDisplayString(_ctx.imageList.length) + " 张)", 1),
                    _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (img, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "image-item"
                            }, [
                                _createElementVNode("img", {
                                    src: img,
                                    alt: '图片' + (index + 1),
                                    onError: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
                                }, null, 40, _hoisted_11),
                                _createElementVNode("p", null, "图片 " + _toDisplayString(index + 1), 1)
                            ]));
                        }), 128))
                    ])
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
